'use client';
import React, { useState } from 'react';
import AdminKPICards from './AdminKPICards';
import AdminChartsRow from './AdminChartsRow';
import AdminBlocksTable from './AdminBlocksTable';
import AdminUsersTable from './AdminUsersTable';
import AdminMiraclesTable from './AdminMiraclesTable';

const tabs = [
  { id: 'overview', label: 'Overview' },
  { id: 'blocks', label: 'Blocks' },
  { id: 'users', label: 'Users' },
  { id: 'miracles', label: 'Miracle Messages' },
];

export default function AdminDashboardContent() {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div>
      {/* Tabs */}
      <div className="flex border-b border-border mb-8 overflow-x-auto">
        {tabs?.map((tab) => (
          <button
            key={`admin-tab-${tab?.id}`}
            onClick={() => setActiveTab(tab?.id)}
            className={`px-6 py-3 text-sm font-medium transition-all duration-200 whitespace-nowrap ${
              activeTab === tab?.id
                ? 'tab-active' :'text-muted-foreground hover:text-foreground border-b-2 border-transparent'
            }`}
          >
            {tab?.label}
          </button>
        ))}
      </div>
      {activeTab === 'overview' && (
        <div className="space-y-8 animate-fade-in">
          <AdminKPICards />
          <AdminChartsRow />
        </div>
      )}
      {activeTab === 'blocks' && (
        <div className="animate-fade-in">
          <AdminBlocksTable />
        </div>
      )}
      {activeTab === 'users' && (
        <div className="animate-fade-in">
          <AdminUsersTable />
        </div>
      )}
      {activeTab === 'miracles' && (
        <div className="animate-fade-in">
          <AdminMiraclesTable />
        </div>
      )}
    </div>
  );
}